import { useCallback } from 'react'
import { Allergen } from '../../types/catalog'
import { ActionsCell, TD, TR } from '../../components/ui/Table'
import { Button } from '../../components/ui/Button'

interface Props {
  item: Allergen
  onEdit: (item: Allergen) => void
  onDelete: (item: Allergen) => void
}

export function AllergenRow({ item, onEdit, onDelete }: Props) {
  const handleEdit = useCallback(() => onEdit(item), [item, onEdit])
  const handleDelete = useCallback(() => onDelete(item), [item, onDelete])

  return (
    <TR>
      <TD>
        <code style={{ fontSize: 12, color: '#9b6bb5' }}>{item.code}</code>
      </TD>
      <TD>{item.translations.find(t => t.locale === 'en')?.name ?? '—'}</TD>
      <TD>{item.translations.find(t => t.locale === 'es')?.name ?? '—'}</TD>
      <ActionsCell>
        <Button variant="ghost" size="sm" onClick={handleEdit}>
          Edit
        </Button>
        <Button variant="danger" size="sm" onClick={handleDelete}>
          Delete
        </Button>
      </ActionsCell>
    </TR>
  )
}
